import {
  useTranslate,
  IResourceComponentsProps,
  useShow,
} from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { ILanguage } from "interfaces";

const { Title, Text } = Typography;

export const LanguageShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { queryResult } = useShow<ILanguage>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>{t("language.fields.lang_code")}</Title>
      <Text>{record?.lang_code}</Text>

      <Title level={5}>{t("language.fields.name")}</Title>
      <Text>{record?.name}</Text>
    </Show>
  );
};
